import React from 'react';
import { Tooltip, Typography, withStyles } from '@material-ui/core';
import { VButton } from '@venti-components';
import { Stack } from '@mui/material';
import styles from './EventListItem.styles';
import permissions from '../../../Providers/Permissions/Permissions';
import { copyToClipboard, formatDate, getEventLink } from '../../../utils/utils';
import { useAuth } from '../../../Providers/AuthProvider/AuthProvider';
import { useNotifications } from '../../../Providers/NotificationsProvider/NotificationsProvider';

const EventListItem = ({ classes, event, customDomainUrl }) => {
  const { name, promoImg, startDate, producerId, description, id } = event;
  const { showNotification } = useNotifications();
  const { user } = useAuth();
  const { role } = user;

  const copyToClipboardEventLink = () => {
    copyToClipboard(
      getEventLink(event, user, customDomainUrl),
      showNotification,
      'Enlace copiado!'
    );
  };

  return (
    <div className={classes.itemContainer}>
      <div className={classes.titleMobileContainer}>
        <Typography className={classes.titleMobile}>{name}</Typography>
        <Typography className={classes.startDateMobile}>{formatDate(startDate)}</Typography>
      </div>
      <div className={classes.imageAndInfoContainer}>
        <img alt="Event_image" className={classes.image} src={promoImg} />
        <div className={classes.infoContainer}>
          <Tooltip title={name} followcursor="true">
            <Typography className={classes.titleDesktop}>{name}</Typography>
          </Tooltip>
          <Typography className={classes.startDateDesktop}>{formatDate(startDate)}</Typography>
          <Typography className={classes.description}>{description}</Typography>
        </div>
      </div>
      <Stack direction="column" gap={1} sx={{ minWidth: { xs: '100%', md: 'max-content' } }}>
        {permissions.isSeller(role) ? (
          <VButton
            label="Copiar mi link"
            onClick={copyToClipboardEventLink}
            variant="secondary"
            icon="chain-link-3"
            fullWidth="always"
          />
        ) : (
          <VButton
            href={getEventLink(event, user, customDomainUrl)}
            variant="secondary"
            label="Ver evento"
            fullWidth="always"
          />
        )}
        <VButton
          variant="outlined"
          href={`/backoffice/productoras/${producerId}/eventos/${id}`}
          label="Opciones"
          icon="settings-gear-2"
          fullWidth="always"
        />
      </Stack>
    </div>
  );
};

export default withStyles(styles)(EventListItem);
